export enum StatusEnum {
  DRAFT = 'Draft',
  PENDING_ACTIVATION = 'Pending Activation',
  PENDING_ACCEPTANCE = 'Pending Acceptance',
  ACTIVE = 'Active',
  CANCELLED = 'Cancelled',
  SUSPENDED = 'Suspended',
  EXPIRED = 'Expired',
}